import script from "./Invitations.vue?vue&type=script&setup=true&lang=js"
export * from "./Invitations.vue?vue&type=script&setup=true&lang=js"

import "./Invitations.vue?vue&type=style&index=0&id=fd8ede2e&lang=scss"

const __exports__ = script;

export default __exports__